export default "__VITE_ASSET__BpmIa4uP__"